"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _AuButton = _interopRequireDefault(require("./AuButton"));
var _AuInput = _interopRequireDefault(require("./AuInput"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _BootstrapDialog = _interopRequireDefault(require("./BootstrapDialog"));
var _constants = require("../../constants");
var _fetch = require("../../network/fetch");
var _domain = require("../../utils/domain");
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "title": "au_domain_bootstrap-module__title___gAmLX",
  "msg": "au_domain_bootstrap-module__msg___qktt1",
  "domain_input": "au_domain_bootstrap-module__domain_input___ZCFwC",
  "message_box": "au_domain_bootstrap-module__message_box___MEj2x"
};
class AuDomainBootstrap extends _react.Component {
  static propTypes = {
    callback: T.func.isRequired
  };
  state = {
    userDomain: '',
    hasError: false
  };
  submitUserDomain = (0, _bind.default)(_context = this.submitUserDomain).call(_context, this);
  submitUserDomain() {
    const {
      userDomain
    } = this.state;
    let domain = (0, _domain.parseDomain)(userDomain);
    if (domain) {
      this.setState({
        hasError: false
      }, () => (0, _fetch.fetchJson)(`/config/${domain}/application.json`).then(() => {
        localStorage.setItem(_constants.USER_DOMAIN_KEY, domain);
        this.props.callback(domain);
      }, () => this.setState({
        hasError: true
      })));
    } else {
      this.setState({
        hasError: true
      });
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_BootstrapDialog.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.message_box
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.domainbootstrap.title",
      className: styles.title,
      tag: "h2"
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.domainbootstrap.msg",
      className: styles.msg,
      tag: "p"
    }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      autoFocus: true,
      name: "userdomain",
      className: styles.domain_input,
      type: "text",
      value: this.state.userDomain,
      placeholderId: "au.domainbootstrap.placeholder",
      showError: this.state.hasError,
      error: {
        fieldDisplayId: 'au.noop',
        errDisplayId: 'au.domainbootstrap.retrieveError'
      },
      onKeyDown: ev => {
        const key = ev.key;
        if (key === _constants.ENTER_KEY) {
          this.submitUserDomain();
        }
      },
      onChange: ev => {
        const {
          value
        } = ev.target;
        this.setState({
          userDomain: (0, _trim.default)(value).call(value).toLowerCase()
        });
      },
      tabIndex: 0
    }), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      className: styles.button,
      type: "primary",
      size: "regular",
      displayId: "au.domainbootstrap.enter",
      onClick: this.submitUserDomain
    })));
  }
}
exports.default = AuDomainBootstrap;